import { createFileRoute, redirect } from "@tanstack/react-router";
import AdminProtectedRoute from "@/components/admin/AdminProtectedRoute";
import Admin from "@/pages/Admin";
import { resolveAdminRedirect } from "@/lib/adminRedirects";

// El componente se declara como función con nombre (no exportada) para que el
// compilador pueda sacarlo del bundle inicial.
function AdminRouteComponent() {
  return (
    <AdminProtectedRoute>
      <Admin />
    </AdminProtectedRoute>
  );
}

export const Route = createFileRoute("/admin")({
  // Fase 2b: las URL fusionadas se redirigen aquí (layout común de /admin/*),
  // antes de la comprobación de acceso, conservando los parámetros.
  beforeLoad: ({ location }) => {
    const target = resolveAdminRedirect(location.pathname, location.searchStr ?? "");
    if (target) throw redirect({ href: target, replace: true });
  },
  component: AdminRouteComponent,
});
